// Maps block type -> {Editor, renderPreview}. BlockCard.jsx falls back to
// GenericBlockEditor for any type not present here.
import TextBlockEditor, { renderTextPreview } from './TextBlockEditor';
import ListBlockEditor, { renderListPreview } from './ListBlockEditor';
import MediaBlockEditor, { renderMediaPreview } from './MediaBlockEditor';
import TrueFalseEditor, { renderTrueFalsePreview } from './TrueFalseEditor';
import OrderingEditor, { renderOrderingPreview } from './OrderingEditor';
import MultipleChoiceEditor, { renderMultipleChoicePreview } from './MultipleChoiceEditor';
import FillBlankEditor, { renderFillBlankPreview } from './FillBlankEditor';
import MatchingEditor, { renderMatchingPreview } from './MatchingEditor';
import EssayEditor, { renderEssayPreview } from './EssayEditor';
import SentenceOrderEditor, { renderSentenceOrderPreview } from './SentenceOrderEditor';
import ErrorSpottingEditor, { renderErrorSpottingPreview } from './ErrorSpottingEditor';
import EmbedConversationPicker, { renderEmbedConversationPreview } from './EmbedConversationPicker';
import EmbedGridPicker, { renderEmbedGridPreview } from './EmbedGridPicker';
import VideoEmbedEditor, { renderVideoEmbedPreview } from './VideoEmbedEditor';

const BLOCK_EDITOR_REGISTRY = {
    heading: { Editor: TextBlockEditor, renderPreview: renderTextPreview },
    text: { Editor: TextBlockEditor, renderPreview: renderTextPreview },
    list: { Editor: ListBlockEditor, renderPreview: renderListPreview },
    image: { Editor: MediaBlockEditor, renderPreview: renderMediaPreview },
    audio: { Editor: MediaBlockEditor, renderPreview: renderMediaPreview },
    video: { Editor: MediaBlockEditor, renderPreview: renderMediaPreview },
    video_embed: { Editor: VideoEmbedEditor, renderPreview: renderVideoEmbedPreview },
    true_false: { Editor: TrueFalseEditor, renderPreview: renderTrueFalsePreview },
    ordering: { Editor: OrderingEditor, renderPreview: renderOrderingPreview },
    multiple_choice: { Editor: MultipleChoiceEditor, renderPreview: renderMultipleChoicePreview },
    fill_blank: { Editor: FillBlankEditor, renderPreview: renderFillBlankPreview },
    matching: { Editor: MatchingEditor, renderPreview: renderMatchingPreview },
    essay: { Editor: EssayEditor, renderPreview: renderEssayPreview },
    // audio_response reuses EssayEditor as-is - identical {prompt} config
    // shape/form, same "one editor, several type keys" convention already
    // used for heading/text and image/audio/video above.
    audio_response: { Editor: EssayEditor, renderPreview: renderEssayPreview },
    sentence_order: { Editor: SentenceOrderEditor, renderPreview: renderSentenceOrderPreview },
    error_spotting: { Editor: ErrorSpottingEditor, renderPreview: renderErrorSpottingPreview },
    embed_conversation: { Editor: EmbedConversationPicker, renderPreview: renderEmbedConversationPreview },
    embed_grid: { Editor: EmbedGridPicker, renderPreview: renderEmbedGridPreview },
};

export default BLOCK_EDITOR_REGISTRY;
